var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockWait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12.7059 7.29412C12.7059 6.90427 12.3898 6.58824 12 6.58824C11.6102 6.58824 11.2941 6.90427 11.2941 7.29412V12C11.2941 12.2434 11.4195 12.4696 11.6259 12.5986L14.4494 14.3633C14.78 14.5699 15.2155 14.4694 15.4221 14.1388C15.6287 13.8082 15.5282 13.3727 15.1976 13.1661L12.7059 11.6088V7.29412Z",
    fill: "#EC6468"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockWait);
export default __webpack_public_path__ + "static/media/clock-wait.1dceb4e9a94367e16fe9b52365355604.svg";
export { ForwardRef as ReactComponent };